var _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCabriolet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 18,
    viewBox: "0 0 44 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.583 14.3517C11.583 14.7661 11.5277 15.1676 11.4242 15.5492H32.5673C32.6175 15.5434 32.6685 15.5376 32.7204 15.5317C32.6199 15.1553 32.5663 14.7597 32.5663 14.3517C32.5663 11.8323 34.6087 9.78988 37.1281 9.78988C39.6475 9.78988 41.6899 11.8323 41.6899 14.3517C41.6899 14.4173 41.6885 14.4825 41.6858 14.5474C42.1954 14.4961 42.5285 14.4658 42.6033 14.4658C42.442 13.2964 42.6514 12.9824 42.8282 12.7174C42.9014 12.6076 42.969 12.5062 43.0024 12.3559C43.1165 11.8427 43.0024 11.1014 42.2041 10.4742C42.0557 8.58233 41.4006 7.60748 40.9608 6.9531C40.7245 6.60156 40.5504 6.34251 40.5504 6.08345C40.5504 5.49041 41.1967 5.41818 41.5198 5.45619C41.5768 5.05704 41.4628 4.25873 40.5504 4.25873C39.6381 4.25873 37.2811 5.05704 36.2167 5.45619L35.6237 4.25873L35.6237 4.2588C35.7137 3.90199 35.7886 3.58296 35.8176 3.40339C35.9126 2.81416 35.9822 1.61854 34.8874 1.61854C33.7926 1.61854 33.2908 2.24579 33.1945 2.71912C33.1567 2.9053 33.4097 3.01373 33.685 3.13172C33.9876 3.2614 34.3172 3.40264 34.3172 3.67135C34.3172 4.18455 33.5937 5.45619 32.6813 6.08345H29.4881C29.4501 5.36116 29.2942 3.81395 28.9749 3.40339C28.5757 2.89019 26.865 3.40339 26.694 3.91659C26.6036 4.18782 26.8158 4.3157 27.0275 4.44334C27.2165 4.55721 27.4051 4.67089 27.3782 4.88598C27.3326 5.25092 26.4849 5.83635 26.0667 6.08345H18.7108V4.88598H17.6274V6.08345H16.3159V5.45619C17.2472 4.60086 19.2012 2.79895 19.5661 2.43401C20.0223 1.97783 20.0794 1.23653 19.5661 0.552257C19.1556 0.00484055 18.2926 0.324167 17.9125 0.552257L11.583 5.45619C8.78891 5.76031 2.85859 7.06423 1.49005 9.84693C0.18869 12.493 1.56853 14.4551 2.54066 15.2134C2.48732 14.9343 2.45939 14.6463 2.45939 14.3517C2.45939 11.8323 4.50178 9.78988 7.0212 9.78988C9.54061 9.78988 11.583 11.8323 11.583 14.3517Z",
    fill: "#BABABA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.02054,
    cy: 14.3526,
    r: 2.90815,
    stroke: "#BABABA",
    strokeWidth: 1.48259
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.2432,
    cy: 14.3526,
    r: 2.90815,
    stroke: "#BABABA",
    strokeWidth: 1.48259
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabriolet);
export default ForwardRef;